import { useTranslation } from 'react-i18next';
import './style.css';
import { formatDate } from '@/utils/dateUtils';

const RequestOverview = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className="patient-request-overview-section">
            <div className="patient-request-overview-item">
                <div className="patient-request-overview-icon patient-request-overview-icon-category">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M3 9H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9 21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="patient-request-overview-content">
                    <span className="patient-request-overview-label">{t('category').toUpperCase()}</span>
                    <p className="patient-request-overview-value">{data?.category}</p>
                </div>
            </div>

            <div className="patient-request-overview-item">
                <div className="patient-request-overview-icon patient-request-overview-icon-subcategory">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="patient-request-overview-content">
                    <span className="patient-request-overview-label">{t('subcategory').toUpperCase()}</span>
                    <p className="patient-request-overview-value">{data?.subCategory}</p>
                </div>
            </div>

            <div className="patient-request-overview-item">
                <div className="patient-request-overview-content-dates">
                    <span className="patient-request-overview-label">{t('requested-dates').toUpperCase()}</span>
                    <div className="patient-request-overview-dates">
                        <div className="patient-request-overview-date-item">
                            <span className="patient-request-overview-date-label">{t('start-date')}</span>
                            <p className="patient-request-overview-date-value">{ data?.startDate?.split(" ")?.[0] }</p>
                        </div>
                        <div className="patient-request-overview-date-item">
                            <span className="patient-request-overview-date-label">{t('end-date')}</span>
                            <p className="patient-request-overview-date-value">{data?.endDate?.split(" ")?.[0]}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RequestOverview;

